import React, { useCallback, useMemo, useState } from "react";
import ModalContext from "../../../context/modal";

const ModalProvider = ({ children }) => {
  const [modalState, setState] = useState(() => ({
    visible: false,
    title: null,
    body: null,
    backdrop: true,
    large: false,
    timestamp: Date.now(),
  }));
  const hideModal = useCallback(
    () => setState((s) => ({ ...s, title: null, body: null, backdrop: true, visible: false, large: false })),
    [],
  );
  const showModal = useCallback(
    (title, body) =>
      setState((s) => ({ ...s, title, body, backdrop: true, visible: true, large: false, timestamp: Date.now() })),
    [],
  );
  const showLargeModal = useCallback(
    (title, body) =>
      setState((s) => ({ ...s, title, body, backdrop: true, visible: true, large: true, timestamp: Date.now() })),
    [],
  );
  const showStaticModal = useCallback(
    (title, body) =>
      setState((s) => ({ ...s, title, body, backdrop: "static", visible: true, large: false, timestamp: Date.now() })),
    [],
  );
  const showLargeStaticModal = useCallback(
    (title, body) => setState((s) => ({ ...s, title, body, backdrop: "static", visible: true, large: true })),
    [],
  );
  const updateModalTitle = useCallback((title) => setState((s) => ({ ...s, title })), []);
  const updateModalBody = useCallback((body) => setState((s) => ({ ...s, body, timestamp: Date.now() })), []);
  const state = useMemo(
    () => ({
      ...modalState,
      hideModal,
      showModal,
      showLargeModal,
      showStaticModal,
      showLargeStaticModal,
      updateModalTitle,
      updateModalBody,
    }),
    [
      hideModal,
      modalState,
      showLargeModal,
      showLargeStaticModal,
      showModal,
      showStaticModal,
      updateModalBody,
      updateModalTitle,
    ],
  );

  return <ModalContext.Provider value={state}>{children}</ModalContext.Provider>;
};

export default ModalProvider;
